import { useEffect, useState } from "react";
import { Clock, KeyRound } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import { actividad, http, marcarActividad } from "../../lib/api";
import { useAuth } from "../../lib/auth";

const EVENTOS = ["mousedown", "keydown", "touchstart", "scroll", "wheel"];

export const InactividadGuard = () => {
  const { user, logout } = useAuth();
  const [restante, setRestante] = useState(null);
  const limite = (user?.inactividad_min || 30) * 60000;
  useEffect(() => {
    let ult = 0;
    const on = () => { if (Date.now() - ult > 1000) { ult = Date.now(); marcarActividad(); } };
    EVENTOS.forEach((e) => window.addEventListener(e, on, { passive: true }));
    const t = setInterval(() => {
      if (actividad.enCurso > 0) marcarActividad();
      const r = limite - (Date.now() - actividad.ultima);
      if (r <= 0) { clearInterval(t); sessionStorage.setItem("logout_motivo", "Sesión cerrada por inactividad"); logout("inactividad"); }
      else setRestante(r <= 120000 ? r : null);
    }, 1000);
    const ping = setInterval(() => { if (Date.now() - actividad.ultima < 60000) http.get("/auth/ping").catch(() => null); }, 120000);
    return () => { EVENTOS.forEach((e) => window.removeEventListener(e, on)); clearInterval(t); clearInterval(ping); };
  }, [limite, logout]);
  const seguir = () => { marcarActividad(); setRestante(null); http.get("/auth/ping").catch(() => null); };
  return (
    <Dialog open={restante !== null} onOpenChange={(o) => !o && seguir()}>
      <DialogContent data-testid="inactividad-modal" className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Clock size={18} className="text-[#E8643C]" />¿Sigues ahí?</DialogTitle>
          <DialogDescription>Por seguridad, tu sesión se cerrará por inactividad en <b data-testid="inactividad-restante">{Math.ceil((restante || 0) / 1000)} s</b>.</DialogDescription>
        </DialogHeader>
        <div className="mt-2 flex gap-2">
          <button onClick={seguir} className="flex-1 rounded-full bg-[#111] py-2.5 text-sm font-semibold text-white" data-testid="inactividad-seguir">Seguir conectado</button>
          <button onClick={() => logout()} className="rounded-full border border-[#E2DDD5] px-4 py-2.5 text-sm" data-testid="inactividad-salir">Cerrar sesión</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export const PwdAviso = () => {
  const { user, setCambio } = useAuth();
  const d = user?.password_expira_dias;
  if (d === null || d === undefined || d > (user.pwd_aviso_dias || 10)) return null;
  return (
    <div className="flex items-center justify-center gap-2 bg-[#FFF8E6] px-4 py-1.5 text-center text-xs text-[#8A5A00]" data-testid="pwd-expira-aviso">
      <KeyRound size={13} />Tu contraseña vence en {Math.max(d, 0)} {d === 1 ? "día" : "días"}.
      <button onClick={() => setCambio(true)} className="font-semibold underline" data-testid="pwd-expira-cambiar">Cámbiala ahora</button>
    </div>
  );
};
